<template>
  <div class="n-checkbox">
    <input type="checkbox" :id="id" v-model="checkbox" @change="update" :disabled="disabled" />
    <label :for="id" v-html="label" />
  </div>
</template>
<script>
import { logWithPrefix } from "@/plugins/logging";
const log = logWithPrefix("[components/elements/dniCheckbox.vue]");
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
    config: {
      type: [String, Number, Boolean, Array],
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    trueLabel: {
      type: [String, Number, Boolean],
      default: true,
    },
    falseLabel: {
      type: [String, Number, Boolean],
      default: false,
    },
    multi: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    config: {
      handler() {
        // if (typeof this.config == "object") log("config", this.id);
        if (
          (!this.multi && this.config == this.trueLabel) ||
          (this.multi && this.config.includes(this.trueLabel))
        ) {
          this.checkbox = true;
        } else {
          this.checkbox = false;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      checkbox: "",
    };
  },
  methods: {
    update() {
      log("checkbox", this.checkbox);
      if (this.checkbox) {
        if (this.multi) {
          const newArr = this.config;
          newArr.push(this.trueLabel);
          this.$emit("update:config", newArr);
        } else {
          this.$emit("update:config", this.trueLabel);
        }
      } else {
        if (this.multi) {
          const newArr = this.config.filter((o) => {
            return o != this.trueLabel;
          });
          this.$emit("update:config", newArr);
        } else {
          this.$emit("update:config", this.falseLabel);
        }
      }
      this.$emit("change");
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";

.n-checkbox {
  position: relative;
  cursor: pointer;
  text-align: left;
  display: inline-block;
  input[type="checkbox"] {
    position: absolute;
    opacity: 0;
    pointer-events: none;
  }
  // input[type="checkbox"] {
  //   position: absolute;
  //   opacity: 0;
  //   pointer-events: none;
  // }
  input[type="checkbox"] + label {
    padding-left: $formLabelFontSize + 10;
    display: inline-block;
  }
  input[type="checkbox"]:disabled + label {
    color: $formGrayOutFontColor;
    cursor: not-allowed;
  }
  input[type="checkbox"] + label::before {
    content: " ";
    width: $formLabelFontSize;
    height: $formLabelFontSize;
    border: solid 1px $formBorderColor;
    background: #fff;
    border-radius: 2px;
    position: absolute;
    left: 0;
    top: ($formLineHeight - $formLabelFontSize)/2 - 2;
  }
  input[type="checkbox"]:hover + label::before {
    border: solid 1px $formCheckBoxColor;
  }
  input[type="checkbox"]:checked + label::before {
    content: " ";
    border: solid 1px $formCheckBoxColor;
    background: $formCheckBoxColor;
  }
  input[type="checkbox"]:checked + label::after {
    content: " ";
    border: 1px solid #fff;
    border-left: 0;
    border-top: 0;
    height: 7px;
    left: $formLabelFontSize/2 - 1;
    position: absolute;
    top: ($formLineHeight - $formLabelFontSize)/2;
    transform: rotate(45deg) scaleY(1);
    width: 3px;
    transition: transform 0.15s ease-in 0.05s;
    transform-origin: center;
  }
  input[type="checkbox"]:disabled + label::before {
    border-color: $formGrayOutColor;
  }
  input[type="checkbox"]:disabled:checked + label::before {
    background: $formGrayOutColor;
  }
}
.n-checkbox.no-label-checkbox {
  input[type="checkbox"] + label::before {
    top: 2px;
  }
  input[type="checkbox"]:checked + label::after {
    top: 5px;
  }
}
.oneline {
  .n-checkbox {
    display: inline-block;
    margin-right: 4px;
  }
}
.n-checkbox.bold {
  label {
    font-weight: 500;
  }
}
.orbi.gui-2-1 {
  .n-checkbox.no-label-checkbox {
    input[type="checkbox"] + label::before {
      top: 4px;
    }
    input[type="checkbox"]:checked + label::after {
      top: 6px;
    }
  }
}
.smb-gui.orbi.gui-2-1 {
  .card {
    input[type="checkbox"] + label {
      font-family: "Roboto-Regular";
    }
  }
}
</style>
